import {DataGrid} from "@mui/x-data-grid";
import { useAppData } from "./appDataContext.js";
import { Paper, Typography, Button, FormControl, Select, InputLabel, MenuItem} from "@material-ui/core"
import { makeStyles } from '@material-ui/core/styles';
import GetRole from "./user";
import {useEffect, useState} from "react"
import {CSVLink} from "react-csv"
import {preventDoubleClick} from "./preventDC.js"
import { fetchActiveTrips, fetchActiveTripsbyTripOwner, fetchEmployees, fetchTripsbyStatusandOwner, fetchTripsbyStatus,fetchActiveTripsbyTL, fetchDest, fetchTripbyId, fetchTripsbyStatusTL, updateTripdata, fetchQuotebyId, updatequoteData, ggwacampaign2, newsearchQEbyDate, getluxuryquotes, fetchTripsbyDest, fetchQMTrips } from "../api/customerapi";
import DateCalc, { getquality, addMinutesToISODate, filterQuotes } from "./date";

const useStyles = makeStyles((theme) => ({
    paper: {
      marginLeft: theme.spacing(10),
      marginRight: theme.spacing(10),
      marginBottom: theme.spacing(5),
      marginTop: theme.spacing(4),
      justifyContent: "center",
      backgroundColor: "#f8f8f8"
    },
    headertext: {
        marginTop: theme.spacing(2),
        marginBottom: theme.spacing(2),
    },
    button: {
      marginLeft: theme.spacing(1),
      marginRight: theme.spacing(4),
      width: theme.spacing(15),
      height: theme.spacing(4),
      marginTop: theme.spacing(3),
      marginBottom: theme.spacing(2),
      fontSize:10
    },
}));

const Listtripsdata = () => {

const classes = useStyles();
const width = window.innerWidth-200;
//console.log(width);
const columns = [
  { field: 'trip_id', 
  headerName: ' Trip ID', 
  width: width/12,
  cellClassName: "gridcell"
  //align:"center",
  //headerAlign:"center"
},
  {
    field: 'cust_name',
    headerName: 'Name',
    width: width/12*1.5,
    
  },
  {
    field: 'primary_destination',
    headerName: 'Primary Destination',
    width: width/12*1.5,
  },
  {
    field: 'trip_created_date',
    headerName: 'Trip Created Date',
    width: width/12*2,
  },
  {
    field: 'trip_updated_date',
    headerName: 'Last FUP Date',
    width: width/12*1.5,
  },
  {
    field: 'trip_owner',
    headerName: 'Trip Owner',
    width: width/12*1.5,
  },
  {
    field: 'trip_start_date',
    headerName: 'Trip Start Date',
    width: width/12*1.5,
  },
  {
    field: 'trip_status',
    headerName: 'Trip Status',
    width: width/12*1.5,
        /*valueGetter: (params) =>
      `${params.getValue(params.id, 'firstName') || ''} ${
        params.getValue(params.id, 'lastName') || ''
      }`,*/
  },
  {
    field: 'pax',
    headerName: 'Pax',
    width: width/12,
      }
];
const columns2 = [
  { field: 'trip_id', 
  headerName: ' Trip ID', 
  width: width/12,
  cellClassName: "gridcell"
  //align:"center",
  //headerAlign:"center"
},
  {
    field: 'cust_name',
    headerName: 'Name',
    width: width/12*1.5,
    
  },
  {
    field: 'primary_destination',
    headerName: 'Primary Destination',
    width: width/12*1,
  },
  {
    field: 'trip_created_date',
    headerName: 'Trip Created Date',
    width: width/12*1.5,
  },
  {
    field: 'trip_updated_date',
    headerName: 'Last FUP Date',
    width: width/12*1.5,
  },
  {
    field: 'trip_owner',
    headerName: 'Trip Owner',
    width: width/12*1,
  },
  {
    field: 'trip_start_date',
    headerName: 'Trip Start Date',
    width: width/12*1.5,
  },
  {
    field: 'trip_status',
    headerName: 'Trip Status',
    width: width/12*1,
  },
  {
    field: 'status',
    headerName: 'Lead Quality',
    width: width/12,
      },
      {
        field: 'pax',
        headerName: 'Pax',
        width: width/12,
          }
];
const headers=[
        {label:"Owner", key:"trip_owner"},
        {label:"Name", key:"cust_name"},
        {label:"Trip Id", key:"trip_id"},
        {label:"Destination", key:"primary_destination"},
        {label:"Created Date", key:"trip_created_date"},
        {label:"Updated Date", key:"trip_updated_date"},
        {label:"Start Date", key:"trip_start_date"},
        {label:"Pax", key:"pax"},
        {label:"Lead Quality", key:"status"},
        {label:"Trip Status", key:"trip_status"},
    ]
const [listtripData, setlisttripData]=useState([{
          
          
  start_date_undecided: "No",
  
  primary_destination: "",
  number_adults: 2,
  number_child: 0,
  type_of_vacation: "Honeymoon",
  duration: 4,
  trip_stage: "Plan in progress",
  trip_channel: "Unknown",
  trip_requirements: "",
  trip_campaign: "",
  multi_destinations: "No",
  secondary_destinations: "",
  trip_status: "",
  status_history:[],
  trip_owner:"",
  follow_up:[{
      status: "Open",
      notes: "",
  }],
}]);
const [listtripData22, setlisttripData22]=useState([{
          
          
  start_date_undecided: "No",
  
  primary_destination: "",
  number_adults: 2,
  number_child: 0,
  type_of_vacation: "Honeymoon",
  duration: 4,
  trip_stage: "Plan in progress",
  trip_channel: "Unknown",
  trip_requirements: "",
  trip_campaign: "",
  multi_destinations: "No",
  secondary_destinations: "",
  trip_status: "",
  status_history:[],
  trip_owner:"",
  follow_up:[{
      status: "Open",
      notes: "",
  }],
}]);
const [listtripData3, setlisttripData3]=useState([]);
const [selection, setselection] = useState([]);
const [working, setworking]=useState(false);
const [isOwner, setisOwner]=useState(true);
const [dest, setdest]=useState([])
const [assignlist, setassignlist]=useState([])
const [leadfilterData, setleadfilterData]=useState({})
const [leadfilterData2, setleadfilterData2]=useState({})
const [emp, setemp]=useState([])
const [emp2, setemp2]=useState([])
const [showall, setshowall]=useState(false)

var {cuser, role}=GetRole();
var l1=[]
//var l22=[]
const loadtrips = async (id) => {
  try{
  
    const data = await fetchActiveTrips();
    var l1=data.data.filter(tripdata => tripdata.trip_status !== "Converted")
    //console.log(l1)
    //l22=[...l1]
    setlisttripData22(l1)
    setlisttripData(l1)
    //l1=data.data.filter(tripdata => tripdata.trip_status !== "Converted")
  
}catch(err){
  console.log(err)
}
}

const loadqm = async (id) => {
  try{
  
    const data = await fetchQMTrips();
    
    //console.log(l1)
    //l22=[...l1]
    setlisttripData22(data.data)
    setlisttripData(data.data)
    //l1=data.data.filter(tripdata => tripdata.trip_status !== "Converted")
  
}catch(err){
  console.log(err)
}
}

const loadtripsbystatus = async (id) => {
  try{
  if(leadfilterData.trip_status){
    const data = await fetchTripsbyStatus(leadfilterData.trip_status);
    //console.log(data.data)
    setlisttripData22(data.data)
    setlisttripData(data.data)
  
    //l22=[...data.data]
  }else{
  alert("Select status first")
    //l1=data.data.filter(tripdata => tripdata.trip_status !== "Converted")
  }
}catch(err){
  console.log(err)
}
}

const loadtripsbyowner = async (id) => {
  try{
  if(leadfilterData.trip_owner){
    const data = await fetchActiveTripsbyTripOwner(leadfilterData.trip_owner);
    //console.log(data.data)
    setlisttripData22(data.data)
    setlisttripData(data.data)
   
    //l22=[...data.data]
  }else{
  alert("Select owner first")
    //l1=data.data.filter(tripdata => tripdata.trip_status !== "Converted")
  }
}catch(err){
  console.log(err)
}
}

const loadtripsbydest = async (id) => {
  try{
  if(leadfilterData.destination){
    const data = await fetchTripsbyDest(leadfilterData.destination);
    //console.log(data.data)
    setlisttripData22(data.data)
    setlisttripData(data.data)
    
    //l22=[...data.data]
  }else{
  alert("Select dest first")
    //l1=data.data.filter(tripdata => tripdata.trip_status !== "Converted")
  }
}catch(err){
  console.log(err)
}
}
// console.log(listtripData3)
// console.log(listtripData22)
// console.log(listtripData)
const getTripsbyTripOwner = async (owner, id) => {
  try{
  //console.log("owner")
  const data = await fetchActiveTripsbyTripOwner(owner);
  setlisttripData(data.data)
  setlisttripData22(data.data)
}catch(err){
  console.log(err)
}
  //console.log(followupData)
}

const getTripsbyTL = async (owner) => {
  try{
  if(leadfilterData.trip_owner && leadfilterData.trip_status){
    const data = await fetchTripsbyStatusandOwner(leadfilterData.trip_status,leadfilterData.trip_owner);
    setlisttripData(data.data)
    setlisttripData22(data.data)
    l1=data.data
  }else if(leadfilterData.trip_owner){
    const data = await fetchActiveTripsbyTripOwner(leadfilterData.trip_owner);
    setlisttripData(data.data)
    setlisttripData22(data.data)
    l1=data.data
  } else if(leadfilterData.trip_status){
    const data = await fetchTripsbyStatusTL(leadfilterData.trip_status, owner);
    setlisttripData(data.data)
    setlisttripData22(data.data)
    l1=data.data
  }else{
    const data = await fetchActiveTripsbyTL(owner);
    l1=data.data.filter(tripdata => tripdata.trip_status !== "Converted")
    setlisttripData(l1)
    setlisttripData22(l1)
    //l1=data.data.filter(tripdata => tripdata.trip_status !== "Converted")
  }
  //console.log("owner")
}catch(err){
  console.log(err)
}
  //console.log(followupData)
}

const getEmployees = async () => {
  try{
  
  //const custdatalistfromdb= data.data
  // if(role=="TL"){
  //   const data = await fetchTeambyName(cuser);
  //   const empshortname = data.data.map((emp) => emp.short_name);
  //   setemp(empshortname);
  // }else{
  //   const data = await fetchEmployees();
  //   const empsplist = data.data.filter((emp) => emp.role == "Sales" || emp.role == "TL");
  //   const empshortname = empsplist.map((emp) => emp.short_name);
  //   setemp(empshortname);
  // }
  const data = await fetchEmployees();
    const empsplist = data.data.filter((emp) => emp.role == "Sales" || emp.role == "TL" || emp.role == "SME");
    const empshortname = empsplist.map((emp) => emp.short_name);
    let sortedemp = empshortname.sort()
    setemp(sortedemp);
    const empshortname2 = data.data.map((emp) => emp.short_name);
    let sortedemp2 = empshortname2.sort()
    setemp2(sortedemp2);
  }catch(err){
    console.log(err)
  }
  
};

const getDest = async () => {
  try{
  const data = await fetchDest();
  //console.log(data.data)
  const temp=data.data.filter(d=>"order" in d)
  // setalldest(data.data)
  setdest(temp[0].dest);
}catch(err){
  console.log(err)
}
};

useEffect(() => {
  getEmployees()
  getDest()
  if(role=="Sales"  || role=="SME" ){
    getTripsbyTripOwner(cuser)
  }
}, [cuser, role])

const changeisOwner=() => {
  
  setisOwner(!isOwner)
  if(!isOwner){
    role="Sales"
  
  }else{
  role="Admin"
  }
  role == "Admin"  || role=="Manager" || role=="Operations-TL" ? loadtrips() : getTripsbyTripOwner(cuser)

}


if(leadfilterData.trip_owner && leadfilterData.trip_status){
  l1=listtripData.filter(tripdata => tripdata.trip_owner==leadfilterData.trip_owner && tripdata.trip_status==leadfilterData.trip_status)
}else if(leadfilterData.trip_owner){
  l1=listtripData.filter(tripdata => tripdata.trip_owner==leadfilterData.trip_owner)
} else if(leadfilterData.trip_status){
  l1=listtripData.filter(tripdata => tripdata.trip_status==leadfilterData.trip_status)
}else{
  l1=listtripData.filter(tripdata => tripdata.trip_status !== "Converted")
}
if(leadfilterData.destination){
  l1=listtripData.filter(tripdata => tripdata.primary_destination==leadfilterData.destination)
}
if(leadfilterData.group_trip){
  l1=l1.filter(tripdata => tripdata.group_trip==leadfilterData.group_trip)
}
if(leadfilterData.type){
  l1=l1.filter(tripdata => tripdata.type_of_vacation==leadfilterData.type)
}
if(leadfilterData.dest){
  l1=l1.filter(tripdata => tripdata.primary_destination==leadfilterData.dest)
}
if(leadfilterData.potential){
  if(leadfilterData.potential=="Yes"){
    l1=l1.filter(tripdata => "lead" in tripdata && "potential" in tripdata.lead && tripdata.lead.potential)
  }else{
    l1=l1.filter(tripdata => "lead" in tripdata && !("potential" in tripdata.lead))
  }
  
}
if(leadfilterData.model){
  if(leadfilterData.model=="Beta"){
    l1=l1.filter(tripdata => "lead" in tripdata && "model_beta" in tripdata.lead && tripdata.lead.model_beta=="Beta")
  }else{
    l1=l1.filter(tripdata => "lead" in tripdata && !("model_beta" in tripdata.lead && tripdata.lead.model_beta=="Beta"))
  }
  
}
if(leadfilterData.qp){
  l1=l1.filter(tripdata => tripdata.quote_pending==leadfilterData.qp)
}

if(leadfilterData.qm){
  l1=l1.filter(tripdata =>!("quote" in tripdata && tripdata.quote.length>0))
  l1=l1.filter(tripdata=>!("manual_quote" in tripdata && tripdata.manual_quote==false))
}


  
  const tripdatalistdisplay=l1.map(tripdata=>({cust_name: tripdata.cust_name, 
    id:l1.indexOf(tripdata), 
    trip_id:tripdata.trip_id, 
    primary_destination:tripdata.primary_destination, 
    trip_owner:tripdata.trip_owner, 
    trip_status:tripdata.trip_status, 
    trip_start_date:"trip_start_date" in tripdata? String(tripdata.trip_start_date).slice(0,10): "", 
    trip_created_date: tripdata.createdAt ===undefined ? "" : tripdata.createdAt.slice(0,10),
    trip_updated_date:tripdata.follow_up.length>0?new Date(tripdata.follow_up[tripdata.follow_up.length-1].createdAt).toLocaleString("en-IN"):"",
    pax:"number_child" in tripdata?tripdata.number_adults+tripdata.number_child:tripdata.number_adults
  }))

    const tripdatalistdisplay2=l1.map(tripdata=>({cust_name: tripdata.cust_name, 
      id:l1.indexOf(tripdata), 
      trip_id:tripdata.trip_id, 
      primary_destination:tripdata.primary_destination, 
      trip_owner:tripdata.trip_owner, 
      trip_status:tripdata.trip_status, 
      trip_start_date:"trip_start_date" in tripdata? String(tripdata.trip_start_date).slice(0,10): "", 
      trip_created_date: tripdata.createdAt ===undefined ? "" : tripdata.createdAt.slice(0,10),
      trip_updated_date:tripdata.follow_up.length>0?new Date(tripdata.follow_up[tripdata.follow_up.length-1].createdAt):"",
      status:(("lead") in tripdata)?getquality(tripdata.lead.lead_status, tripdata.lead.time_to_book, tripdata.trip_channel, tripdata.trip_start_date,tripdata.lead.quality_upgrade,null):getquality(null, null, tripdata.trip_channel, tripdata.trip_start_date,null, null),
      pax:"number_child" in tripdata?tripdata.number_adults+tripdata.number_child:tripdata.number_adults
      // call:calltrue2(tripdata),
    }));

  const gridcellclick=(id)=>{
    window.open("/tripdataentry/" + id, '_blank');
    //console.log("/custdataentry/"+id);
  }

  const addforassign=()=>{
    if(leadfilterData.assign_to == undefined){
      alert("Missing sales person name to add")
    } else if(selection.length==0){
      alert("No item selected")
    }else{
      const triplist=selection.map(select => tripdatalistdisplay[select].trip_id)
      console.log(triplist);
      const temp={
        name:leadfilterData.assign_to,
        list:triplist,
      }
      setassignlist([...assignlist, temp])
    }
  }

  const addcoupon=async()=>{
    try{
      let nd=new Date()
      let code=prompt("Enter Code:")
      let amount=prompt("Enter Amount:")
      let hours=prompt("Enter Hours of validity:")
      setworking(true)
      const tempcoupon={
        code:code,
        expiry:addMinutesToISODate(nd, hours*60),
        amount:Number(amount),
      }
      console.log(tempcoupon)
      const triplist=selection.map(select => tripdatalistdisplay[select].trip_id)
      console.log(triplist);
      for(let i=0; i<triplist.length; i++){
        const data = await fetchTripbyId(triplist[i]);
        if("quote" in data.data && data.data.quote.length>0){
          for(let j=0; j<data.data.quote.length; j++){
          const data2=await fetchQuotebyId(data.data.quote[j])
          const temp={...data2.data,  coupon:data2.data.coupon.length>0?[...data2.data.coupon, tempcoupon]:[tempcoupon], quote_discount:Number(amount)}
          const updateQuoteResponse= await updatequoteData(data2.data._id,temp)
          
        }
        const wamsg={
          name:data.data.cust_name,
          number:"91"+data.data.primary_mobile_number,
          amount:amount,
          expiry:hours,
          destination:data.data.primary_destination,
        }
        const data2=await ggwacampaign2(wamsg)
        console.log(data2)
      }
      if(i==triplist.length-1) {
        setworking(false)
      }
      }
      
    }catch(e){
      console.log(e)
    }
  }

  const assign= async() => {
    try{
    if(assignlist.length<=0){
      alert("List and name not found")
    }
    else {
      setworking(true)
      console.log(assignlist)
      for (let i=0;i<assignlist.length;i++){
        for(let j=0 ;j<assignlist[i].list.length ;j++){
        const data = await fetchTripbyId(assignlist[i].list[j]);
        data.data.trip_owner=assignlist[i].name
        
        const updatetripResponse = await updateTripdata(data.data._id, data.data);
        }
      }
      window.location.reload();
    }
  }catch(err){
    console.log(err)
  }
  };
  //console.log(listtripData2)
  const filterbyQE=async()=>{
    try{
      //console.log(l22)
      if(leadfilterData.day_qe==""){
        setlisttripData([...listtripData22])
      }else{
      var startdate, enddate
      if(leadfilterData.day_qe==1){
        startdate=DateCalc(0)
        enddate=DateCalc(1)
      }
       if(leadfilterData.day_qe==3){
        startdate=DateCalc(-3)
        enddate=DateCalc(1)
      }
       if(leadfilterData.day_qe==5){
        startdate=DateCalc(-5)
        enddate=DateCalc(1)
      }
          const data = await newsearchQEbyDate(
                startdate,
                enddate
              );
              console.log(data.data)
             const filtered = filterQuotes(data.data);
              console.log(filtered);
              //const khushik=filtered.filter(t=>t.trip_owner=="KhushiK")
              //console.log(khushik.length)
              ///const ajay=filtered.filter(t=>t.trip_owner=="Ajay")
              //console.log(ajay.length)
              if(listtripData22 && listtripData22.length>0){
                const tripIdsInArray2 = new Set(filtered.map(item => item.trip_id));
                console.log(tripIdsInArray2)
                console.log(listtripData22)
                var x= listtripData22.filter(item => tripIdsInArray2.has(item.trip_id));
                console.log(x)
                setlisttripData(x)
              }
           
            }
      if("luxury" in leadfilterData2 && leadfilterData2.luxury){
        const data=await getluxuryquotes()
        console.log(data.data)
        const tripIdsInArray22 = new Set(data.data.map(item => item.trip_id));
        var xx= listtripData.filter(item => tripIdsInArray22.has(item.trip_id));
        setlisttripData(xx)
      }
    }catch(err){
    console.log(err)
  }
  }

  

    return ( 
      <div>
      {role && emp.length>0 ?(
        <Paper variant="outlined" className={classes.paper}> 
        <Typography variant="h4" align="center" className={classes.headertext}> View Trips</Typography>
        <div align="center">
        
        
                
          {role=="TL" ?(<div>
          
            <FormControl style={{minWidth: 240, marginTop: 16, marginRight: 32, marginLeft: 8}}>
            <InputLabel id="trip owner">Trip Owner</InputLabel>
                <Select displayEmpty className={classes.textField} InputLabelProps={{ shrink: true }} labelId="Trip Owner" value={leadfilterData.trip_owner} onChange={(e)=> setleadfilterData({...leadfilterData, trip_owner: e.target.value})}>
                <MenuItem value={""}>Clear</MenuItem>
                <MenuItem value={"Amit"}>Amit</MenuItem>
                {emp.map((emp) => {
                return <MenuItem value={emp}>{emp}</MenuItem>;
              })}
              </Select>
                </FormControl>
                 <FormControl
            style={{
              minWidth: 320,
              marginTop: 16,
              marginRight: 32,
              marginLeft: 8,
            }}
          >
          
            <InputLabel id="Trip Status">Trip Status</InputLabel>
            <Select
              displayEmpty
              classname={classes.textField}
              labelId="Trip Status"
              value={leadfilterData.trip_status}
              InputLabelProps={{ shrink: true }}
              onChange={(e) =>
                setleadfilterData({ ...leadfilterData, trip_status: e.target.value })
              }
            >
            <MenuItem value={""}>Clear</MenuItem>
              <MenuItem value={"New"}>New</MenuItem>
              <MenuItem value={"Active"}>Active</MenuItem>
              
              <MenuItem value={"Hot"}>Hot</MenuItem>
             
              <MenuItem value={"Converted"}>Converted</MenuItem>
              <MenuItem value={"Postponed"}>Postponed</MenuItem>
              
            </Select>
          </FormControl>   
                
                
                
                <Button onClick={preventDoubleClick(()=>getTripsbyTL(cuser))} variant="contained"  color="inherit" className={classes.button}>Load</Button>
                {selection && selection.length>0?(
                <Button onClick={()=>addcoupon()} variant="contained"  color="secondary" className={classes.button}>Bulk Coupon</Button>
              ):("")}
          </div>
            
          ):("")}

         

          {role=="Admin" || role=="Manager" || role=="Operations" || role=="Operations-TL" || role=="Product"?(<div>
             <FormControl style={{minWidth: 160, marginTop: 16, marginRight: 32, marginLeft: 8}}>
            <InputLabel id="Destination">Destination</InputLabel>
                <Select displayEmpty className={classes.textField} InputLabelProps={{ shrink: true }} labelId="Destination" value={leadfilterData.destination} onChange={(e)=> setleadfilterData({...leadfilterData, destination: e.target.value})}>
                <MenuItem value={""}>Clear</MenuItem>
                {dest.map((d) => {
                return <MenuItem value={d}>{d}</MenuItem>;
              })}
              </Select>
                </FormControl>
                <Button onClick={preventDoubleClick(loadtripsbydest)} variant="contained"  color="inherit" className={classes.button}>Load</Button>
            <FormControl
            style={{
              minWidth: 160,
              marginTop: 16,
              marginRight: 32,
              marginLeft: 8,
            }}
          >
          
            <InputLabel id="Trip Status">Trip Status</InputLabel>
            <Select
              displayEmpty
              classname={classes.textField}
              labelId="Trip Status"
              value={leadfilterData.trip_status}
              InputLabelProps={{ shrink: true }}
              onChange={(e) =>
                setleadfilterData({ ...leadfilterData, trip_status: e.target.value })
              }
            >
            <MenuItem value={""}>Clear</MenuItem>
              <MenuItem value={"New"}>New</MenuItem>
              <MenuItem value={"Active"}>Active</MenuItem>
              
              <MenuItem value={"Hot"}>Hot</MenuItem>
             
              <MenuItem value={"Converted"}>Converted</MenuItem>
              <MenuItem value={"Postponed"}>Postponed</MenuItem>
              <MenuItem value={"Dropped After Booking"}>Dropped After Booking</MenuItem>
            </Select>
          </FormControl>  
            <Button onClick={loadtripsbystatus} variant="contained"  color="inherit" className={classes.button}>Load</Button>    
                {showall?(
                  <FormControl style={{minWidth: 320, marginTop: 16, marginRight: 32, marginLeft: 8}}>
            <InputLabel id="trip owner">Trip Owner</InputLabel>
                <Select displayEmpty className={classes.textField} InputLabelProps={{ shrink: true }} labelId="Trip Owner" value={leadfilterData.trip_owner} onChange={(e)=> setleadfilterData({...leadfilterData, trip_owner: e.target.value})}>
                <MenuItem value={""}>Clear</MenuItem>
                <MenuItem value={"Amit"}>Amit</MenuItem>
                <MenuItem value={"Asgar"}>Asgar</MenuItem>
                <MenuItem value={"NitinK"}>NitinK</MenuItem>
                {emp2.map((emp) => {
                return <MenuItem value={emp}>{emp}</MenuItem>;
              })}
              
                    
                
                </Select>
                </FormControl>
                ):(
                  <FormControl style={{minWidth: 160, marginTop: 16, marginRight: 32, marginLeft: 8}}>
            <InputLabel id="trip owner">Trip Owner</InputLabel>
                <Select displayEmpty className={classes.textField} InputLabelProps={{ shrink: true }} labelId="Trip Owner" value={leadfilterData.trip_owner} onChange={(e)=> setleadfilterData({...leadfilterData, trip_owner: e.target.value})}>
                <MenuItem value={""}>Clear</MenuItem>
                <MenuItem value={"Amit"}>Amit</MenuItem>
                <MenuItem value={"Asgar"}>Asgar</MenuItem>
                <MenuItem value={"NitinK"}>NitinK</MenuItem>
                {emp.map((emp) => {
                return <MenuItem value={emp}>{emp}</MenuItem>;
              })}
              
                    
                
                </Select>
                </FormControl>
                
                )}
           
                <Button onClick={loadtripsbyowner} variant="contained"  color="inherit" className={classes.button}>Load</Button>
                <Button onClick={loadtrips} variant="contained"  color="inherit" className={classes.button}>Load All</Button>
                <Button onClick={loadqm} variant="contained"  color="inherit" className={classes.button}>Quote Missing</Button>
                {selection && selection.length>0?(
                <Button onClick={()=>addcoupon()} variant="contained"  color="secondary" className={classes.button}>Bulk Coupon</Button>
              ):("")}
          </div>
            
          ):("")}

          {role=="Sales"  || role=="SME" ?(
            <FormControl
            style={{
              minWidth: 320,
              marginTop: 16,
              marginRight: 32,
              marginLeft: 8,
            }}
          >
          
            <InputLabel id="Trip Status">Trip Status</InputLabel>
            <Select
              displayEmpty
              classname={classes.textField}
              labelId="Trip Status"
              value={leadfilterData.trip_status}
              InputLabelProps={{ shrink: true }}
              onChange={(e) =>
                setleadfilterData({ ...leadfilterData, trip_status: e.target.value })
              }
            >
            <MenuItem value={""}>Clear</MenuItem>
              <MenuItem value={"New"}>New</MenuItem>
              <MenuItem value={"Active"}>Active</MenuItem>
              
              <MenuItem value={"Hot"}>Hot</MenuItem>
             
              <MenuItem value={"Converted"}>Converted</MenuItem>
              <MenuItem value={"Postponed"}>Postponed</MenuItem>
              
            </Select>
          </FormControl>  
          ):("")}

          <FormControl style={{minWidth: 240, marginTop: 16, marginRight: 32, marginLeft: 8}}>
            <InputLabel id="qp">Quote Pending</InputLabel>
                <Select displayEmpty className={classes.textField} InputLabelProps={{ shrink: true }} labelId="QP" value={leadfilterData.qp} onChange={(e)=> setleadfilterData({...leadfilterData, qp: e.target.value})}>
                <MenuItem value={""}>Clear</MenuItem>
                <MenuItem value={1}>1</MenuItem>
                
              
                    
                
                </Select>
                </FormControl>
                <FormControl style={{minWidth: 240, marginTop: 16, marginRight: 32, marginLeft: 8}}>
            <InputLabel id="qm">Quote Missing</InputLabel>
                <Select displayEmpty className={classes.textField} InputLabelProps={{ shrink: true }} labelId="QM" value={leadfilterData.qm} onChange={(e)=> setleadfilterData({...leadfilterData, qm: e.target.value})}>
                <MenuItem value={""}>Clear</MenuItem>
                <MenuItem value={1}>1</MenuItem>
                
              
                    
                
                </Select>
                </FormControl>
                <FormControl
            style={{
              minWidth: 240,
              marginTop: 16,
              marginRight: 32,
              marginLeft: 8,
            }}
          >
          
            <InputLabel id="Potential">Potential</InputLabel>
            <Select
              displayEmpty
              classname={classes.textField}
              labelId="Potential"
              value={leadfilterData.potential}
              InputLabelProps={{ shrink: true }}
              onChange={(e) =>
                setleadfilterData({ ...leadfilterData, potential: e.target.value })
              }
            >
            <MenuItem value={""}>Clear</MenuItem>
              <MenuItem value={"Yes"}>Yes</MenuItem>
              <MenuItem value={"No"}>No</MenuItem>
              
            </Select>
          </FormControl>
               <FormControl
            style={{
              minWidth: 240,
              marginTop: 16,
              marginRight: 32,
              marginLeft: 8,
            }}
          >
          
            <InputLabel id="model">Model</InputLabel>
            <Select
              displayEmpty
              classname={classes.textField}
              labelId="model"
              value={leadfilterData.model}
              InputLabelProps={{ shrink: true }}
              onChange={(e) =>
                setleadfilterData({ ...leadfilterData, model: e.target.value })
              }
            >
            <MenuItem value={""}>Clear</MenuItem>
              <MenuItem value={"Alpha"}>Alpha</MenuItem>
              <MenuItem value={"Beta"}>Beta</MenuItem>
              
            </Select>
          </FormControl>
          <FormControl
            style={{
              minWidth: 240,
              marginTop: 16,
              marginRight: 32,
              marginLeft: 8,
            }}
          >
            <InputLabel id="Type">Type</InputLabel>
            <Select
              
              className={classes.textField}
              labelId="Type"
              value={leadfilterData.type}
              onChange={(e) =>
                setleadfilterData({ ...leadfilterData, type: e.target.value })
              }
            >
              <MenuItem value={""}>Clear</MenuItem>
              <MenuItem value={"Honeymoon"}>Honeymoon</MenuItem>
              <MenuItem value={"Anniversary"}>Anniversary</MenuItem>
              <MenuItem value={"Birthday"}>Birthday</MenuItem>
              <MenuItem value={"Break"}>Break</MenuItem>
              <MenuItem value={"Children-Special"}>Children-Special</MenuItem>
              <MenuItem value={"Nothing-Special"}>Nothing-Special</MenuItem>
              <MenuItem value={"Others"}>Others</MenuItem>
            </Select>
          </FormControl>
          <FormControl
            style={{
              minWidth: 240,
              marginTop: 16,
              marginRight: 32,
              marginLeft: 8,
            }}
          >
            <InputLabel id="Group Trip">Group Trip</InputLabel>
            <Select
              displayEmpty
              classname={classes.textField}
              InputLabelProps={{ shrink: true }}
              labelId="Group Trip"
              value={leadfilterData.group_trip}
              onChange={(e) =>
                setleadfilterData({ ...leadfilterData, group_trip: e.target.value })
              }
            >
            <MenuItem value={""}>Clear</MenuItem>
              <MenuItem value={"Between 10 and 25"}>Between 10 and 25</MenuItem>
              <MenuItem value={"Between 26 and 50"}>Between 26 and 50</MenuItem>
              <MenuItem value={"Greater than 50"}>Greater than 50</MenuItem>
            </Select>
          </FormControl>

          <FormControl style={{minWidth: 240, marginTop: 16, marginRight: 32, marginLeft: 8}}>
            <InputLabel id="Destination">Destination</InputLabel>
                <Select displayEmpty className={classes.textField} InputLabelProps={{ shrink: true }} labelId="Destination" value={leadfilterData.dest} onChange={(e)=> setleadfilterData({...leadfilterData, dest: e.target.value})}>
                <MenuItem value={""}>Clear</MenuItem>
                {dest.map((dest) => {
                return <MenuItem value={dest}>{dest}</MenuItem>;
              })}
                    
                    
                
                </Select>
                </FormControl>

          {role=="Admin" || role=="Manager"?(
            <div>
            <FormControl style={{minWidth: 240, marginTop: 16, marginRight: 32, marginLeft: 8}}>
            <InputLabel id="assign">Assign To</InputLabel>
                <Select displayEmpty className={classes.textField} InputLabelProps={{ shrink: true }} labelId="Assign To" value={leadfilterData.assign_to} onChange={(e)=> setleadfilterData({...leadfilterData, assign_to: e.target.value})}>
                <MenuItem value={"Amit"}>Amit</MenuItem>
               
                {emp.map((emp) => {
                return <MenuItem value={emp}>{emp}</MenuItem>;
              })}
              
                    
                
                </Select>
                </FormControl>

                <Button
            variant="contained"
            color="secondary"
            className={classes.button}
            onClick={addforassign}
          > Add
          </Button>
          
                <Button
            variant="contained"
            color="secondary"
            className={classes.button}
            onClick={assign}
          > Assign
          </Button>
          <Button  variant="contained"  color="primary" className={classes.button} onClick={()=>setshowall(!showall)}>{showall ? "Show Active" : "Show All"} </Button>
                </div>
          ):("")}
          {tripdatalistdisplay2 && tripdatalistdisplay2.length>0 || tripdatalistdisplay && tripdatalistdisplay.length>0?(
               <div align="center">
                <FormControl
            style={{
              minWidth: 240,
              marginTop: 16,
              marginRight: 32,
              marginLeft: 8,
            }}
          >
            <InputLabel id="luxury">Luxury</InputLabel>
            <Select
              displayEmpty
              InputLabelProps={{ shrink: true }}
              className={classes.textField}
              labelId="luxury"
              value={leadfilterData2.luxury}
              onChange={(e) =>
                 setleadfilterData2({ ...leadfilterData2, luxury: e.target.value })
              }
            >
            <MenuItem value={""}>Clear</MenuItem>
            <MenuItem value={1}>1</MenuItem>
            
          
             
             
            </Select>
          </FormControl>
                 <FormControl
            style={{
              minWidth: 240,
              marginTop: 16,
              marginRight: 32,
              marginLeft: 8,
            }}
          >
            <InputLabel id="same_day_qe">QE Filter</InputLabel>
            <Select
              displayEmpty
              InputLabelProps={{ shrink: true }}
              className={classes.textField}
              labelId="same_day_qe"
              value={leadfilterData.day_qe}
              onChange={(e) =>
                 setleadfilterData({ ...leadfilterData, day_qe: e.target.value })
              }
            >
            <MenuItem value={""}>Clear</MenuItem>
            <MenuItem value={1}>1</MenuItem>
            <MenuItem value={3}>3</MenuItem>
            <MenuItem value={5}>5</MenuItem>
             
             
            </Select>
          </FormControl>
           <Button onClick={()=>filterbyQE(cuser)} variant="contained"  color="inherit" className={classes.button}>Filter</Button>
               </div>
          ):("")}
        
        {/* <Button href="/searchtrip" variant="contained"  color="secondary" className={classes.button}>Search Trips</Button> */}
        </div>
        {working?("Working..."):("")}
         {(cuser=="Debayan" || cuser=="Amit") && tripdatalistdisplay2.length>1?(<div>
                   <CSVLink data={tripdatalistdisplay2} headers={headers}>Download CSV</CSVLink>
                   </div>
                ):("")}
        <div style={{ height: 2400, width: '100%' }}>
      <DataGrid rows={(role=="Admin"  || role=="Manager")?tripdatalistdisplay2:tripdatalistdisplay} 
        onCellDoubleClick={(getValue)=>gridcellclick(getValue.row.trip_id)}
        columns={(role=="Admin" || role=="TL" || role=="Manager")?columns2:columns}
        isRowSelectable={(params) => params.row.trip_status!=="Converted"}
        autoPageSize
        checkboxSelection={true}
            onSelectionModelChange={(newSelection) => {
        setselection(newSelection);}}
        // autoHeight
        >      
      </DataGrid>      
    </div>
    </Paper>
     ):("Loading...")}
     </div>
     )
}
 
export default Listtripsdata;